import { ProductsOrder } from "common/order/ProductsOrder";
import { useState, useEffect } from "react";
import laptop from "assets/images/laptop.png";
import mos from "assets/images/mos.png";
import headphone from "assets/images/headphone.png";
import hard from "assets/images/hard.png";
import sharzher from "assets/images/sharzher.png";
import { ProductsRepair } from "common/order/ProductsRepair";
//import "components/orders/orders.scss";
import "common/order/orders.scss";
import ComolatePriceModal from "common/order/ComplatePriceModal";
import StatusReportModal from "common/order/StatusReportModal";
import UpdateRepairModal from "common/order/UpdateRepairModal";
import UpdateOrderModal from "common/order/UpdateOrderModal";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "../hooks/useAxios2";
import { useParams, useSearchParams } from "react-router-dom";
import { useContext } from "react";

export default function Orderstor() {
  let [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  // state info from api
  const [orderLists, setOrderLists] = useState([]);
  const [updater, setUpdater] = useState(false);

  const [selectedItem, setSelectedItem] = useState({});
  const [chatList, setChatList] = useState([]);
  const updateSelectedItem = (information) => {
    setSelectedItem(information);
    setChatList(information.chats);
  };
  const title = (type) => {
    switch (type) {
      case "0":
        return " در انتظار پرداخت ";

      case "1":
        return " در حال پردازش ";

      case "2":
        return " ارسال شده ";

      case "3":
        return " لغو شده ";

      default:
        return " تمامی سفارشات ";
    }
  };
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    sendRequest2("newfilterorder").then(({ data }) => {
      if (type) {
        setOrderLists(
          data.info.reverse().filter((value) => {
            return type == +value.main_status;
          })
        );
      } else {
        setOrderLists(data.info.reverse());
      }
    });
  }, [updater]);

  return (
    <div className="order-container">
      <ComolatePriceModal selectedItem={selectedItem}></ComolatePriceModal>

      <StatusReportModal
        selectedItem={selectedItem}
        pageType="1"
        // chats={selectedItem.chats}
        // chats={chatList}
        // setChats={setChatList}
        setUpdater={setUpdater}
      ></StatusReportModal>
      <UpdateRepairModal selectedItem={selectedItem}></UpdateRepairModal>
      <UpdateOrderModal selectedItem={selectedItem}></UpdateOrderModal>
      <h4 className="text-center mt-4">
        لیست
        {title(type)}
        ها
      </h4>
      {!orderLists.length ? (
        <p className="text-center my-4">برای ثبت سفارش به فروشگاه سر بزنید!</p>
      ) : (
        orderLists
          .slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
          .map((value, index) => {
            if (value.type == "0") {
              return (
                <ProductsOrder
                  data={value}
                  index={index}
                  // chats={value.chats}
                  updateSelectedItem={updateSelectedItem}
                  pageType="user"
                ></ProductsOrder>
              );
            } else {
              return (
                <ProductsRepair
                  data2={value}
                  index={index}
                  updateSelectedItem={updateSelectedItem}
                  pageType="user"
                ></ProductsRepair>
              );
            }
          })
      )}

      <div className="d-flex justify-content-center mt-4">
        <div>
          <Pagination
            total={orderLists.length}
            pageSize={5}
            current={currentPage}
            onChange={(newPage) => {
              setCurrentPage(newPage);
            }}
          ></Pagination>
        </div>
      </div>
    </div>
  );
}
